var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtocol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m17.67,22H6.32c-2.39,0-4.32-1.94-4.33-4.32V6.33c0-2.39,1.94-4.32,4.33-4.33h11.35c2.39,0,4.32,1.94,4.32,4.33v11.35c0,2.39-1.94,4.32-4.32,4.33M6.32,4.08c-1.24,0-2.24,1.01-2.24,2.24v11.35c0,1.24,1.01,2.24,2.24,2.24h11.35c1.24,0,2.24-1,2.24-2.24V6.33c0-1.24-1-2.24-2.24-2.24H6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m17.5,15.79H6.39c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h11.1c.35,0,.62.28.62.62s-.28.62-.62.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m17.5,8.7H6.39c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h11.1c.35,0,.62.28.62.62s-.28.62-.62.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "m17.5,12.44H6.39c-.35,0-.62-.28-.62-.62s.28-.62.62-.62h11.1c.35,0,.62.28.62.62s-.28.62-.62.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocol);
export default __webpack_public_path__ + "static/media/protocol.787e4355ac089fa8888a2dfd2fb3ed50.svg";
export { ForwardRef as ReactComponent };